import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataExchangeCommentDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-comment-dto';

export interface SubRequestCommentsDialogData {
  comments: DataExchangeCommentDto[] | null | undefined;
  title: string;
  allowOptionalComment?: boolean;
  confirmButtonTranslationKey?: string;
}

export interface SubRequestCommentsDialogResult {
  confirmed: boolean;
  comment?: string;
}

@Component({
  selector: 'app-sub-request-comments-dialog',
  templateUrl: './sub-request-comments-dialog.component.html',
  styleUrls: ['./sub-request-comments-dialog.component.scss']
})
export class SubRequestCommentsDialogComponent {
  readonly commentControl = new FormControl('');

  constructor(
    public dialogRef: MatDialogRef<SubRequestCommentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubRequestCommentsDialogData
  ) {}

  onCommentAdded(text: string): void {
    this.dialogRef.close(text);
  }

  onConfirm(): void {
    const comment = this.commentControl.value?.trim();
    const result: SubRequestCommentsDialogResult = {
      confirmed: true,
      comment: comment || undefined,
    };
    this.dialogRef.close(result);
  }
}
